import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { API_BASE_URL } from '../../api';

const Edit_client = ({ client, onClientUpdated }) => {
    const [formData, setFormData] = useState({
        full_name: "",
        company_name: "",
        location: "",
        city: "",
        email_id: "",
        mobile_no: "",
    });

    const [isLoading, setIsLoading] = useState(false);

    // Populate form data when client is selected
    useEffect(() => {
        if (client) {
            setFormData({
                full_name: client.full_name || "",
                company_name: client.company_name || "",
                location: client.location || "",
                city: client.city || "",
                email_id: client.email_id || "",
                mobile_no: client.mobile_no || "",
            });
        }
    }, [client]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        if (!client || !client.id) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Client ID is missing.",
            });
            return;
        }

        try {
            setIsLoading(true);
        
            const headers = {
                authorization: `Bearer ${localStorage.getItem("authToken")}`,
                user_id: localStorage.getItem("userId"),
            };
        
            const response = await axios.put(
                `${API_BASE_URL}/api/client/${client.id}`,
                formData,
                { headers }
            );
        
            if (response.status === 200) {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Client updated successfully!",
                });
                onClientUpdated();
                window.location.reload();
        
                // Close modal programmatically
                const closeButton = document.getElementById("close-edit-modal");
                if (closeButton) {
                    closeButton.click();
                } else {
                    console.error("Close button not found.");
                }
            }
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to update client. Please try again.",
            });
            console.error("Error updating client:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="modal fade" id="edit_client">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content text-start">
                    <div className="modal-header">
                        <h4 className="modal-title">Edit Client</h4>
                        <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade show active" id="basic-info" role="tabpanel" aria-labelledby="info-tab" tabIndex="0">
                                <div className="modal-body pb-0">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Name <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="full_name"
                                                    value={formData.full_name}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Company Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="company_name"
                                                    value={formData.company_name}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Location <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="location"
                                                    value={formData.location}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">City <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="city"
                                                    value={formData.city}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Mobile No <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="mobile_no"
                                                    value={formData.mobile_no}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">Email <span className="text-danger">*</span></label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    name="email_id"
                                                    value={formData.email_id}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-outline-light border me-2" data-bs-dismiss="modal">Cancel</button>
                                    <button type="submit" className="btn btn-primary">
                                        {isLoading ? "Saving..." : "Save"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Edit_client;
